import React from 'react';

import { Route } from 'react-router-dom';
import { Redirect, Switch, useLocation, useRouteMatch } from 'react-router';

import CampaignProductsRouteSwitch from '../campaigns/CampaignProductsRouteSwitch';
import { PageNotFound } from '../PageNotFound';
import { MULTI_LANGUAGE_SHOP, useFeature } from '../../shared/utils/togglz';

const RouteSwitch = () => {
    const { path, url } = useRouteMatch();
    const { pathname, search } = useLocation();
    const isMultiLanguageShopEnabled = useFeature(MULTI_LANGUAGE_SHOP);

    if (isMultiLanguageShopEnabled) {
        return <Redirect to={{ pathname: `/shop/en${pathname}`, search }} />;
    }

    return (
        <Switch>
            <Route path={`${path}/campaigns`}>
                <CampaignProductsRouteSwitch />
            </Route>
            <Route exact path={path}>
                <Redirect to={`${url}/campaigns`} />
            </Route>
            <Route>
                <PageNotFound />
            </Route>
        </Switch>
    );
};

export default RouteSwitch;
